import Nav from '../Components/Common/Nav';
import MainBanner from '../Components/MainBanner';

const Home = () => {
    return (
       <>
        <Nav/>
        <MainBanner/>
       </>
    )
}

export default Home;